import { render, staticRenderFns } from "./AlertIsLocked.vue?vue&type=template&id=6d68132c"
import script from "./AlertIsLocked.vue?vue&type=script&lang=js"
export * from "./AlertIsLocked.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports